import { defineNuxtPlugin } from 'nuxt/app'
import { createPersistedState } from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin(nuxtApp => {
  // Clear persisted state if it might be corrupted (debugging purposes)
  // Uncomment if you're sure you want to reset the storage
  // localStorage.clear()
  
  // For client-side only to avoid SSR issues
  if (import.meta.client) {
    nuxtApp.$pinia.use(createPersistedState({
      storage: localStorage,
      key: id => `blaster_${id}`, // Prefix storage keys to avoid conflicts
      beforeRestore: (context) => {
        console.log(`Restoring state for store: ${context.store.$id}`)
      },
      afterRestore: (context) => {
        console.log(`State restored for store: ${context.store.$id}`)
      }
    }))
  }
})